import type { FileSystemItem } from '@/components/document/sub-components/file-manager/types';

export const filterFileSystemItems = (
  items: FileSystemItem[],
  query: string,
): FileSystemItem[] => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return items;
  return items.filter((item) => item.name.toLowerCase().includes(trimmed));
};
